import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import BG from "../../assets/bg.jpg";
import Start from "./start";
import Confirm from "./confirm";
import Agreement from "@/components/Agreement";
import WaitingNumber from "./waitingNumber";
import CommonWarning from "../../components/warning";
import CRMLogin from "./crm";

const useStyles = makeStyles({
  background: {
    minHeight: "100vh",
    backgroundImage: `url(${BG})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  root: {
    position: "relative",
    paddingTop: 34,
    maxWidth: 600,
    margin: "auto",
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFA439",
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: "10px",
        },
      },
    },
  },
});

export default () => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.background}>
        <CommonWarning />
        <div className={classes.root}>
          <Routes>
            <Route path="start" element={<Start />} />
            <Route path="confirm" element={<Confirm />} />
            <Route path="crmLogin" element={<CRMLogin />} />
            <Route path="waitingNumber" element={<WaitingNumber />} />
            <Route path="*" element={<Navigate to="start" />} />
          </Routes>
          <Agreement />
        </div>
      </div>
    </ThemeProvider>
  );
};
